import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';

import DotsLoading from '../../../../../components/dotsLoading';
import CustomSearchBox from '../../../../../components/mazraeKit/customSearchBox';
import useGetSubInputLists from '../../../../../services/hookService/getSubInputLists/useGetSubInputLists';
import {RootState} from '../../../../../store/redux';
import {clearAdminImages} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addRegisterAdvertisement,
  clearBrandData,
} from '../../../../../store/redux/advertisementRegisteration';

function SubInputList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state} = useLocation();

  const {sub_input} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const [inputValue, setInputValue] = useState('');

  const {data, isLoading} = useGetSubInputLists({
    input: state?.input,
    title: inputValue,
  });

  return (
    <div className="flex flex-col h-full px-3">
      <div className="flex h-[56px] w-full justify-between items-center text-md text-black">
        <div className="flex items-center">
          <i
            className="ml-3 text-xl font-bold icon-nameArrow---Right"
            onClick={() => navigate(-1)}
          />
          <span>انتخاب نوع</span>
        </div>
        <i
          className="text-xl icon-nameClose-remove font-Bold"
          onClick={() => {
            navigate(state?.backRoute, {
              state: {
                subInput: sub_input,
              },
            });
          }}
        />
      </div>
      <hr className="mx-2 mt-0 text-gray-300" />
      <div className="mt-2 ">
        <CustomSearchBox
          placeholder="انتخاب نوع"
          type="text"
          value={inputValue}
          inputCustomClass="!pr-4"
          preIcon="icon-nameSearch"
          onChange={e => setInputValue(e.target.value)}
          {...{inputValue, setInputValue}}
        />
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <DotsLoading />
          </div>
        ) : (
          data?.map(item => (
            <span
              key={item.guid ?? item.code}
              className="py-4 border-b"
              onClick={() => {
                dispatch(
                  addRegisterAdvertisement({
                    sub_input: {
                      guid: item?.guid,
                      title: item?.title,
                      code: item.code,
                    },
                  }),
                );
                dispatch(clearBrandData());
                dispatch(clearAdminImages());
                navigate(-1);
              }}
            >
              {item.title}
            </span>
          ))
        )}
      </div>
    </div>
  );
}

export default SubInputList;
